import { render, staticRenderFns } from "./PosCaptura.vue?vue&type=template&id=2a145531&scoped=true"
import script from "./PosCaptura.vue?vue&type=script&lang=js"
export * from "./PosCaptura.vue?vue&type=script&lang=js"
import style0 from "./PosCaptura.vue?vue&type=style&index=0&id=2a145531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a145531",
  null
  
)

export default component.exports